import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import { computed, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { IncrediTabList, IncrediTab } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { Routes } from '@/router/router.const';
import elementsIds from '@/const/elementIds.json';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { FeatureFlags } from '@/types/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-tabs',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const coordinatorsService = inject(IKCoordinatorsService);
const GQL_CommonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));

const featureFlags = computed<FeatureFlags>(() => (GQL_CommonData?.result?.value?.ibManagerEntities?.featureFlags ? JSON.parse(GQL_CommonData?.result?.value?.ibManagerEntities?.featureFlags) : null));
const onChange = (value: Routes.DashboardGridUtilization | Routes.DashboardWorkloads) => {
  router.push({ name: value });
};
const tabs = computed<
  {
    name: Routes.DashboardGridUtilization | Routes.DashboardWorkloads;
    label: string;
    active: boolean;
    isEnabled: boolean;
    attributes: {
      'data-testid': string;
    };
  }[]
>(() => [
  {
    name: Routes.DashboardWorkloads,
    label: t('dashboard.tabs.workloadOverview.title'),
    active: route.name === Routes.DashboardWorkloads,
    isEnabled: !!featureFlags?.value?.dashboard?.workloads,
    attributes: {
      'data-testid': elementsIds.dashboard.tabs.dashboardWorkloads,
    },
  },
  {
    name: Routes.DashboardGridUtilization,
    label: t('dashboard.tabs.gridUtilization.title'),
    isEnabled: !!featureFlags?.value?.dashboard?.grid_utilization,
    active: route.name === Routes.DashboardGridUtilization,
    attributes: {
      'data-testid': elementsIds.dashboard.tabs.dashboardGridUtilization,
    },
  },
]);

const enabledTabs = computed(() => tabs.value.filter(tab => tab.isEnabled));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { style: {"position":"sticky","top":"0px","z-index":"99"} }, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediTabList), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enabledTabs), (tab, index) => {
            return (_openBlock(), _createBlock(_unref(IncrediTab), _mergeProps({
              key: index,
              index: index,
              active: tab.active,
              class: "!w-[152px]"
            }, tab.attributes, {
              onClick: ($event: any) => (onChange(tab.name))
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tab?.label), 1)
              ]),
              _: 2
            }, 1040, ["index", "active", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})